import { generateId } from '@freelancer/datastore/testing/helpers';
import { ContextTypeApi } from 'api-typings/common/common';
import {
  ProjectCollaborationPermissionApi,
  ProjectCollaborationStatusApi,
} from 'api-typings/projects/projects';
import type { GenerateProjectCollaborationOptions } from '../project-collaborations';
import type { UserCollaboration } from './user-collaborations.model';

export function generateUserCollaborationObject({
  userId,
  projectOwnerId,
  projectId,
  status = ProjectCollaborationStatusApi.ACTIVE,
}: GenerateProjectCollaborationOptions): UserCollaboration {
  return {
    id: generateId(),
    userId,
    context: {
      id: projectId,
      type: ContextTypeApi.PROJECT,
    },
    contextOwnerId: projectOwnerId,
    permissions: [
      ProjectCollaborationPermissionApi.CHAT,
      ProjectCollaborationPermissionApi.BID_AWARD,
    ],
    status,
  };
}
